import React from 'react';

export default function VerticalDashedLines() {
	return (
		<div className="my-2 py-2 flex flex-col gap-[7px] overflow-hidden">
			<div className="w-[1px] h-[5px] bg-dm-grey flex-shrink-0" />
			<div className="w-[1px] h-[9px] bg-dm-grey flex-shrink-0" />
			<div className="w-[1px] h-[9px] bg-dm-grey flex-shrink-0" />
			<div className="w-[1px] h-[9px] bg-dm-grey flex-shrink-0" />
			<div className="w-[1px] h-[5px] bg-dm-grey flex-shrink-0" />
		</div>
	);
}
